/* eslint-disable */
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@wix/ambassador/runtime/http");
exports.WixContactsWebapp = function (baseUrl) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl);
    return {
        ContactsLabelsService: function () {
            return function (headers) {
                var service = {
                    create: function (createLabelRequest) {
                        return httpClient.invoke('POST', '/api/v1/metadata/labels', createLabelRequest, headers);
                    },
                    delete: function (deleteLabelRequest) {
                        return httpClient.invoke('DELETE', '/api/v1/metadata/labels/{id}', deleteLabelRequest, headers);
                    },
                    list: function (listLabelRequest) {
                        return httpClient.invoke('GET', '/api/v1/metadata/labels', listLabelRequest, headers);
                    },
                    update: function (updateLabelRequest) {
                        return httpClient.invoke('PATCH', '/api/v1/metadata/labels/{id}', updateLabelRequest, headers);
                    }
                };
                service.create.__http_method = 'POST';
                service.create.__http_url = '/api/v1/metadata/labels';
                service.delete.__http_method = 'DELETE';
                service.delete.__http_url = '/api/v1/metadata/labels/{id}';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/api/v1/metadata/labels';
                service.update.__http_method = 'PATCH';
                service.update.__http_url = '/api/v1/metadata/labels/{id}';
                return service;
            };
        },
        ContactsSchemaService: function () {
            return function (headers) {
                var service = {
                    createField: function (createFieldRequest) {
                        return httpClient.invoke('POST', '/api/v1/metadata/fields', createFieldRequest, headers);
                    },
                    deleteField: function (deleteFieldRequest) {
                        return httpClient.invoke('DELETE', '/api/v1/metadata/fields/{id}', deleteFieldRequest, headers);
                    },
                    listFields: function (listFieldsRequest) {
                        return httpClient.invoke('GET', '/api/v1/metadata/fields', listFieldsRequest, headers);
                    },
                    updateField: function (updateFieldRequest) {
                        return httpClient.invoke('PATCH', '/api/v1/metadata/fields/{id}', updateFieldRequest, headers);
                    }
                };
                service.createField.__http_method = 'POST';
                service.createField.__http_url = '/api/v1/metadata/fields';
                service.deleteField.__http_method = 'DELETE';
                service.deleteField.__http_url = '/api/v1/metadata/fields/{id}';
                service.listFields.__http_method = 'GET';
                service.listFields.__http_url = '/api/v1/metadata/fields';
                service.updateField.__http_method = 'PATCH';
                service.updateField.__http_url = '/api/v1/metadata/fields/{id}';
                return service;
            };
        },
        ContactsService: function () {
            return function (headers) {
                var service = {
                    create: function (createContactRequest) {
                        return httpClient.invoke('POST', '/api/v3/contacts', createContactRequest, headers);
                    },
                    current: function (currentContactRequest) {
                        return httpClient.invoke('GET', '/api/v3/contacts/current', currentContactRequest, headers);
                    },
                    delete: function (deleteContactRequest) {
                        return httpClient.invoke('DELETE', '/api/v3/contacts/{id}', deleteContactRequest, headers);
                    },
                    get: function (getContactRequest) {
                        return httpClient.invoke('GET', '/api/v3/contacts/{id}', getContactRequest, headers);
                    },
                    list: function (listContactsRequest) {
                        return httpClient.invoke('GET', '/api/v3/contacts', listContactsRequest, headers);
                    },
                    query: function (queryContactsRequest) {
                        return httpClient.invoke('POST', '/api/v3/contacts/query', queryContactsRequest, headers);
                    },
                    update: function (updateContactRequest) {
                        return httpClient.invoke('PATCH', '/api/v3/contacts/{id}', updateContactRequest, headers);
                    }
                };
                service.create.__http_method = 'POST';
                service.create.__http_url = '/api/v3/contacts';
                service.current.__http_method = 'GET';
                service.current.__http_url = '/api/v3/contacts/current';
                service.delete.__http_method = 'DELETE';
                service.delete.__http_url = '/api/v3/contacts/{id}';
                service.get.__http_method = 'GET';
                service.get.__http_url = '/api/v3/contacts/{id}';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/api/v3/contacts';
                service.query.__http_method = 'POST';
                service.query.__http_url = '/api/v3/contacts/query';
                service.update.__http_method = 'PATCH';
                service.update.__http_url = '/api/v3/contacts/{id}';
                return service;
            };
        }
    };
};
exports.WixContactsWebapp.__transport = 'http';
__export(require("./types"));
